import axios from "axios";
import {ElMessage} from "element-plus";
import "element-plus/theme-chalk/el-message.css";
import {useUserstore} from '@/stores/user'
import router from "@/router";

const http = axios.create({
    baseURL: '/api',
    timeout: 10000
})
//拦截器

http.interceptors.request.use(config => {
    console.log(config, 'config')
    const useUsers = useUserstore()
    const {userInfo} = useUsers

    const token = userInfo.token
    if (token && (config.url != '/public/passwordLogin' && config.url != '/public/demoList' && config.url != '/public/demoInfo')) {
        config.headers.Token = token
    }
    return config
})

http.interceptors.response.use(res => {
    const data = res.data;
    if (data.code === 401 || data.code === 5005 || data.code === 5011) {
        const useUsers = useUserstore()
        const {getUserInfo} = useUsers
        getUserInfo({token: ''})
        router.push('/login');
        return res.data;
    }
    return res.data;
}, e => {
    ElMessage({
        type: "warning",
        message: e.response.data.message,
    });
    if (e.response.data.code == 401) {
        const useUsers = useUserstore()
        const {getUserInfo} = useUsers
        getUserInfo({token: ''})
        return router.push('/login')
    }
    return Promise.reject(e)
})

export default http
